import clsx from 'clsx';
import { motion } from 'motion/react'; //eslint-disable-line
import PropTypes from 'prop-types';

export default function Button({
  onButtonClick,
  buttonText,
  variant = 'primary',
  size = 'md',
  disabled = false,
  fullWidth = true,
  className,
  ...props
}) {
  return (
    <motion.button
      {...props}
      whileTap={{ scale: 0.98, y: 1 }}
      onClick={onButtonClick}
      disabled={disabled}
      className={clsx(
        'font-semibold text-sm rounded-lg text-center h-12 max-h-14',
        {
          'bg-primary-button-background hover:bg-primary-button-background/80 active:bg-primary-button-background text-primary-button-text':
            variant === 'primary',
          'bg-secondary-button-background hover:bg-secondary-button-background/80 active:bg-secondary-button-background text-secondary-button-text':
            variant === 'secondary',
          'bg-event-tertiary hover:bg-event-tertiary/80 active:bg-event-tertiary/70 text-event-light':
            variant === 'tertiary',
          'bg-transparent border-2 border-event-primary text-event-primary hover:bg-event-primary/10':
            variant === 'outline',
          'px-3 py-1.5 text-sm': size === 'sm',
          'px-5 py-2.5 text-base': size === 'md',
          'px-6 py-3 text-xl': size === 'lg',
          'w-full': fullWidth,
          'w-auto': !fullWidth,
          'opacity-50 cursor-not-allowed pointer-events-none': disabled,
        },
        className,
      )}
    >
      {buttonText}
    </motion.button>
  );
}

Button.propTypes = {
  onButtonClick: PropTypes.func,
  buttonText: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'tertiary', 'secondary', 'outline']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
};

Button.defaultProps = {
  variant: 'primary',
  size: 'md',
  disabled: false,
  fullWidth: true,
  className: '',
};
